module.exports = __webpack_public_path__ + "static/media/10.aeb50a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/10.png
// module id = 1730
// module chunks = 0